/**Modo de pago mensual */
export class MonthlyPaymentMode {
    /**Cantidad de mese */
    public monthCount: number;
    /**Monto por mes */
    public amountPerMonth: number;

    public constructor();
    public constructor(monthCount: number, amountPerMonth: number);
    public constructor(monthCount?: number, amountPerMonth?: number) {
        this.monthCount = monthCount;
        this.amountPerMonth = amountPerMonth;
    }
}